import * as React from 'react';
import { ReactNode } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import Label from '../Label';
import { IntlShape, useIntl } from 'react-intl';

interface Props {
  title?: string;
  inputId: string;
  value: boolean | null | undefined;
  onChange: (value: boolean | null | undefined) => void;
  disabled?: boolean;
}

export const TitledYesNo: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex align-items-center w-full'}>
      <h4 className={'font-bold flex-grow-1'}>
        <Label
          label={intl.formatMessage({id: `${props.title}.label`})}
          help={intl.formatMessage({id: `${props.title}.help`})}
          disabled={props.disabled}
        />
      </h4>
      <div className={'flex gap-3'}>
        <div className={'flex align-items-center gap-1'}>
          <label htmlFor={`${props.inputId}_yes`} className={'cursor-pointer'}>
            {intl.formatMessage({id: 'label.yes'})}
          </label>
          <Checkbox
            value={'yes'}
            onChange={(event: CheckboxChangeEvent): void => props.onChange(event.target.checked ? true : null)}
            checked={props.value === true}
            inputId={`${props.inputId}_yes`}
            disabled={props.disabled}
          />
        </div>
        <div className={'flex align-items-center gap-1'}>
          <label htmlFor={`${props.inputId}_no`} className={'cursor-pointer'}>
            {intl.formatMessage({id: 'label.no'})}
          </label>
          <Checkbox
            value={'no'}
            onChange={(event: CheckboxChangeEvent): void => props.onChange(event.target.checked ? false : null)}
            checked={props.value === false}
            inputId={`${props.inputId}_no`}
            disabled={props.disabled}
          />
        </div>
      </div>
    </div>
  );
};
